import { PostEditorState, PostEditorPostErrors } from '../../../models/post-editor';
import { isArray } from 'lodash';
import { ErrorMessageSeverity } from '../../../constants/form';
import { postEditorErrorKeys, PostEditorErrorKeys } from '../../../models/validator-props';

const immediateErrorKeys: PostEditorErrorKeys[] = [
  'checkExpiryDate',
  'checkRecurringInterval',
  'facebookTextCharLimit',
  'facebookTwitterLineBreakLimit',
  'googleMinMedia',
  'googleTextCharLimit',
  'instagramFacebookFirstCommentCharLimit',
  'instagramHashtagLimit',
  'instagramTextCharLimit',
  'linkedinFirstCommentCharLimit',
  'linkedinTextCharLimit',
  'noGifsAllowed',
  'noImagesAllowed',
  'noVideosAllowed',
  'pinterestBoardRequired',
  'pinterestLineBreakLimit',
  'pinterestTextCharLimit',
  'preventAudioOnlyFiles',
  'profileRequired',
  'tikTokAudienceRequired',
  'tikTokTextCharLimit',
  'tikTokVideoLength',
  'tikTokVideoSize',
  'titleCharLimit',
  'twitterTextCharLimit'
];

const isPostEditorErrorKeyGuard = (key: string): key is PostEditorErrorKeys =>
  postEditorErrorKeys.map<string>(k => k).includes(key);

export const getErrorsCounter = (postGroups: PostEditorState['postGroups']): [number, number] =>
  postGroups.reduce(
    (prev, curr) => {
      const [prevErr, prevWarn] = prev;
      const { errors: currentPostGroupErrors } = curr;
      const [newErr, newWarn] = Object.entries<PostEditorPostErrors>(currentPostGroupErrors).reduce(
        (prevNumTuple, [key, current]) => {
          if (current && isPostEditorErrorKeyGuard(key)) {
            if (isArray(current)) {
              const w = current.filter(
                e => e.severity === ErrorMessageSeverity.warning && immediateErrorKeys.includes(key)
              ).length;
              const e = current.filter(er => er.severity === ErrorMessageSeverity.error).length;
              return [prevNumTuple[0] + e, prevNumTuple[1] + w];
            } else if (typeof current === 'object') {
              return current.severity === ErrorMessageSeverity.error
                ? [prevNumTuple[0] + 1, prevNumTuple[1]]
                : [prevNumTuple[0], prevNumTuple[1] + (immediateErrorKeys.includes(key) ? 1 : 0)];
            }
          }
          return prevNumTuple;
        },
        [0, 0]
      );
      return [prevErr + newErr, prevWarn + newWarn];
    },
    [0, 0]
  );
